import { AppEvent } from 'types/appEvent';
import { createReducer } from 'utils/reducer/reducerUtils';
import { User } from 'types/state';

export const reduceToNextUser = createReducer<null | User, AppEvent>(
  (prev, event) => {
    switch (event.name) {
      case 'AuthProcess__UserRecieved':
        return event.user;
      case 'PartnerAccountManager__ProfileFormSubmitted': {
        if (prev) {
          return {
            ...prev,
            partnerProfile: {
              ...event.nextPartnerProfile,
            },
          };
        }

        return prev;
      }
      case 'ProdStackManager__PromocodeApplied': {
        if (prev) {
          return {
            ...prev,
            promocodeApplied: true,
          };
        }
        return prev;
      }
      case 'PartnerRegistrationManager__VerificationFormSubmitDidSucceed': {
        if (prev && event.accountInfo) {
          return {
            ...prev,
            accountInfo: event.accountInfo,
          };
        }

        return prev;
      }
      default:
        return prev;
    }
  }
);
